import React from 'react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';

/**
 * Error Boundary Component
 * Catches React errors and displays a fallback UI
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console (could also send to error tracking service)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Optionally reload the page
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          minH="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="gray.50"
          p={4}
        >
          <VStack
            spacing={6}
            maxW="md"
            w="full"
            bg="white"
            p={8}
            borderRadius="lg"
            boxShadow="lg"
          >
            <Heading size="lg" color="red.500">
              エラーが発生しました
            </Heading>
            <Text color="gray.600" textAlign="center">
              申し訳ございません。予期しないエラーが発生しました。
            </Text>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <Box
                w="full"
                p={4}
                bg="red.50"
                borderRadius="md"
                fontSize="sm"
                color="red.800"
                overflowX="auto"
              >
                <Text fontWeight="bold" mb={2}>
                  Error Details:
                </Text>
                <Text fontFamily="mono" whiteSpace="pre-wrap">
                  {this.state.error.toString()}
                </Text>
              </Box>
            )}
            <Button colorScheme="orange" onClick={this.handleReset}>
              ページを再読み込み
            </Button>
          </VStack>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
